(function () {
    'use strict';

    angular.module('swif.openbase')
        .directive('panelSite', panelSite)
        .directive('thumbnailSite', thumbnailSite);

    function panelSite(swif) {
        'ngInject';
        var linked = function(scope) {
            swif.attachment.addAttachments(scope.item);
        };
        // If patrimoine module is installed, require additionnal fields
        var fields = {fields: ['id', 'name', 'type_id', 'site_parent_id', 'surface', 'code', 'lat', 'long', 'street', 'street2', 'zip', 'city']};
        var filter = swif.settings.app.modules.openstc_patrimoine ? fields : undefined;
        var directive = swif.panel.create_directive('site', filter, linked);
        directive.scope.carousel = '=?';
        directive.templateUrl = 'partials/openbase/panel-site.html';
        return directive;
    }

    function thumbnailSite(swif) {
        'ngInject';
        var ret = swif.panel.create_directive('site');
        ret.scope.light = '=?';
        ret.templateUrl = 'partials/openbase/thumbnail-site.html';
        return ret;
    }
})();
